import axios from 'axios';

import { LOGIN, LOGOUT, USER_LOADING, USER_LOADED, AUTH_ERROR } from './types';
import { API_ENDPOINT } from '../config/api';

// CHECK TOKEN & LOAD USER
export const login = (username, password) => dispatch => {
    axios({
        method: 'post',
        url: `${API_ENDPOINT}/api-token-auth/`,
        headers: {
            "Content-Type": "application/json",
        },      
        data: {
            username: username,
            password: password,
        }
    }).then(
        res => {
            dispatch({
                type:LOGIN,
                payload:res.data
            })
        }
    ).catch(err => console.log(err));
}

export const logout = () => dispatch => {
    dispatch({
        type:LOGOUT,
    })
}


export const loadUser = () => (dispatch, getState) => {

    dispatch({type:USER_LOADING});

    const token = getState().auth.token;

    if(token){
        const url= `${API_ENDPOINT}/api-token-verify/`;
        axios.post(
            url,{
            headers:{
                'Content-Type':'application/json',
            },
            token:token}
        ).then(res=>{
            dispatch({
                type:USER_LOADED,
                payload:res.data
            });
        }).catch(err=>{
            dispatch({
                type:AUTH_ERROR,
            });
            
        });
    }
    else {
        dispatch({
            type:AUTH_ERROR,
        });
    }


}